<template>
  <div class="flex flex-row items-center p-24">
    <RevSkeleton height="72px" shape="rectangle" width="72px" />
    <div class="ml-8 space-y-4">
      <RevSkeleton height="24px" shape="rectangle" width="150px" />
      <RevSkeleton height="20px" shape="rectangle" width="120px" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { RevSkeleton } from '@ds/components/Skeleton'
</script>

<style scoped></style>
